import { getInspectionTypeById } from "apiClient/v2/inspection/inspectionTypeApi";
import useProjectBimFile from "hooks/useBimFile";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "redux/store";
import { routePath } from "routes/path";
import useFetchTargetObjects from "../hooks/useFetchTargetObjects";
import { useInspectionDetailDispatch } from "./inspectionDetail";
import { Types } from "./inspectionDetailReducer";

export default function useInspectionDetail() {
  const { bimId, id, projectId } = useParams();
  const { isSyncOfflineData } = useSelector((state: RootState) => state.app);
  const navigate = useNavigate();
  const [loadingStatus, setLoadingStatus] = useState({
    inspection: true,
    dataProjectDetail: true,
  });

  const dispatchContext = useInspectionDetailDispatch();

  useProjectBimFile({
    projectId,
    bimId,
    onLoadedDataProjectDetail: () => {
      setLoadingStatus((prev) => ({ ...prev, dataProjectDetail: false }));
    },
  });

  useFetchTargetObjects();

  useEffect(() => {
    (async () => {
      if (isSyncOfflineData) {
        return;
      }

      if (!id) {
        return navigate(routePath.NotFound);
      }
      const result = await getInspectionTypeById(id);
      const inspectionType = result?.data;

      if (!inspectionType) {
        return navigate(routePath.NotFound);
      }

      dispatchContext({
        type: Types.UPDATE_INSPECTION_TYPE,
        payload: inspectionType,
      });
      setLoadingStatus((prev) => ({ ...prev, inspection: false }));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isSyncOfflineData]);

  useEffect(() => {
    if (!bimId) {
      return navigate(routePath.NotFound);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bimId]);

  const isLoading = useMemo(() => {
    return Object.values(loadingStatus).some((val) => val);
  }, [loadingStatus]);

  return {
    isLoading,
  };
}
